// Reusable chip filter pro multi-select.
// Použití:
//   <ChipFilter
//     label="Stav"
//     options={[{ id: 'pending_intake', label: 'Čeká' }, ...]}
//     value={['pending_intake', 'in_progress']}
//     onChange={setStatusFilter}
//   />
//
// Volitelně `tones` — mapa id → tone (success/warning/danger/info) pro
// barevné odlišení selected chipu. Default = accent pro všechny.

const TONE_COLORS = {
  success: { bg: 'var(--ct-success)', fg: '#fff' },
  warning: { bg: 'var(--ct-warning)', fg: '#fff' },
  danger: { bg: 'var(--ct-error)', fg: '#fff' },
  info: { bg: 'var(--ct-info)', fg: '#fff' },
  accent: { bg: 'var(--ct-accent)', fg: '#fff' },
};

export default function ChipFilter({
  label,
  options,
  value = [],
  onChange,
  tones = {},
  allowClear = true,
  className = '',
}) {
  const toggle = (optId) => {
    if (value.includes(optId)) onChange(value.filter(v => v !== optId));
    else onChange([...value, optId]);
  };
  const clear = () => onChange([]);

  return (
    <div className={`flex items-center gap-1.5 flex-wrap ${className}`}>
      {label && <span className="ct-eyebrow flex-shrink-0">{label}:</span>}
      {options.map(opt => {
        const isSelected = value.includes(opt.id);
        const tone = TONE_COLORS[tones[opt.id] || 'accent'];
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => toggle(opt.id)}
            className="text-xs px-2.5 py-1 rounded-full transition-colors whitespace-nowrap"
            style={{
              background: isSelected ? tone.bg : 'var(--ct-surface)',
              color: isSelected ? tone.fg : 'var(--ct-text-secondary)',
              border: `1px solid ${isSelected ? tone.bg : 'var(--ct-border)'}`,
            }}
          >
            {opt.label}
          </button>
        );
      })}
      {allowClear && value.length > 0 && (
        <button
          type="button"
          onClick={clear}
          className="text-[11px] px-2 py-0.5 rounded transition-opacity hover:opacity-80"
          style={{ color: 'var(--ct-text-disabled)' }}
          title="Zrušit filtr"
        >
          Zrušit
        </button>
      )}
    </div>
  );
}
